export { MarketoForm } from './marketo-form';
export type { MarketoFormInstance, MarketoFormProps, MarketoForms2API } from './marketo-form.types';

// Export sub-components for advanced usage
export { MarketoFormElement } from './components/marketo-form-element';
export { MarketoFormShimmer } from './components/marketo-form-shimmer';
export { MarketoScript } from './components/marketo-script';
export { MarketoStylesheets } from './components/marketo-stylesheets';

// Export hooks for custom implementations
export { useMarketoForm } from './hooks/use-marketo-form';

// Export utilities for advanced customization
export { injectArrowIntoButton } from './utils/button-enhancement';
export { disableMarketoStylesheets, removeMarketoStyles } from './utils/form-styling';
